import PropTypes from 'prop-types'
import styled from 'styled-components'

import { FadeUp } from '@happymoneyinc/move'

import Container from '../../components/Container'
import Display from '../../components/Display'
import Headline from '../../components/Headline'

const Stats = (props) => {
  const {
    jobsCount,
    data: {
      stats: [
        {
          eyebrow,
          value
        }
      ]
    }
  } = props

  return (
    <Wrapper maxWidth="1120px">
      <FadeUp>
        <Inner>
          <Box>
            <StyledHeadline >{eyebrow}</StyledHeadline>
            <StyledDisplay element="h2">{value}</StyledDisplay>
          </Box>

          <Box>
            <StyledHeadline >Open Positions:</StyledHeadline>
            <StyledDisplay element="h2">{jobsCount.toString()}</StyledDisplay>
          </Box>
        </Inner>
      </FadeUp>
    </Wrapper>
  )
}

const Inner = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  margin: 0 auto;
  gap: 80px;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.md }) {
    flex-direction: row;
    justify-content: space-between;
    gap: 60px;
  }
`

const Box = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.md }) {
    align-items: flex-start;
  }
`

const StyledDisplay = styled(Display)`
  margin: 0;
`

const StyledHeadline = styled(Headline)`
  margin: 0 0 18px;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.md }) {
    margin: 0;
  }
`

const Wrapper = styled(Container)`
  background-color: ${ ({ theme }) => theme.colors.ultraviolet[3] };
`

Stats.propTypes = {
  data: PropTypes.shape({
    stats: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobsCount: PropTypes.number.isRequired,
}

export default Stats
